module.exports = __webpack_public_path__ + "static/media/acute.d834bbd6.svg";